<div class="online-container">
    <div class="online" *ngIf="online">
        <p>{{ labels.ONLINE }}</p>
    </div>
    <div class="offline" *ngIf="!online">
        <p>{{ labels.OFFLINE }}</p>
    </div>
</div>